const AddCommentIcon = () => {
  return (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.49961 0.5L4.09961 4.9" stroke="#1F1E26" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.5 0.5L5.7 8.5L4.1 4.9L0.5 3.3L8.5 0.5Z" stroke="#1F1E26" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default AddCommentIcon